import { pList, rOyakKiraBilgileriYillarWrapper, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKKIRATRGENELIYILLIKGELIRDAGILIMILISTELE,
    new Api.Stat.OyakKiraTrGeneliYillikGelirDagilimiListele().Request(body),
    false,
    true,
    body
  );

export const action_async_complete = (
  data: rValue<rOyakKiraBilgileriYillarWrapper> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakKiraBilgileriYillarWrapper> =>
  ActionFunctions.action_async_complete_api<rOyakKiraBilgileriYillarWrapper>(
    ActionSubTypes.API_OYAKKIRATRGENELIYILLIKGELIRDAGILIMILISTELE,
    new rOyakKiraBilgileriYillarWrapper({
      KiraBilgileri: data?.Value?.KiraBilgileri || [],
      AnahtarTuru: '',
      DegerTuru: '',
      Yillar: data?.Value?.Yillar || [],
    }),
    error
  );
